export default "data:video/mp2t;base64,Y29uc3QgU0RLX0xJU1QgPSB7CiAgQ0FTSEZSRUU6ICdjYXNoZnJlZS1zZGsnCn07CgpleHBvcnQgZGVmYXVsdCBTREtfTElTVDsK"